"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdSchedulerUpdateEventName = void 0;
var AdSchedulerUpdateEventName;
(function (AdSchedulerUpdateEventName) {
    AdSchedulerUpdateEventName["AD_RESOURCE_RESOLVED"] = "adresourceresolved";
    AdSchedulerUpdateEventName["AD_RESOURCE_RESOLVE_FAILED"] = "adresourceresolvefailed";
    AdSchedulerUpdateEventName["AD_BLOCKER_STATE_CHANGED"] = "adblockerstatechanged";
    AdSchedulerUpdateEventName["AD_ROLL_BEFORE_START"] = "adrollbeforestart";
    AdSchedulerUpdateEventName["METADATA_RECEIVED"] = "metadatareceived";
})(AdSchedulerUpdateEventName = exports.AdSchedulerUpdateEventName || (exports.AdSchedulerUpdateEventName = {}));
//# sourceMappingURL=ad-scheduler.js.map